import { StateService } from '@uirouter/angular';
import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { ScmService } from '../../../../plugins/scm/services/scm.service';
import { TrackeritemRest } from '../../services/trackeritem.rest';
import { UiService } from '../../../../core/services/core.ui.service';
import { GfTranslateService } from '../../../../core/services/core.translate.service';

@Component({
  selector: 'ti-merge',
  template: require('./trackeritem.merge-tab.component.html')
})
export class MergeTabComponent implements OnInit, OnChanges {
  @Input() trackeritem: any;
  @Input() tiMerge: any;

  constructor(
    private stateService: StateService,
    private scmService: ScmService,
    private trackeritemRest: TrackeritemRest,
    private uiService: UiService,
    private translateService: GfTranslateService
  ) {}

  ngOnInit() {
    this.tiMerge.toBranchCustom = {
      searching: false,
      name: '',
      searchItemsResult: [],
      autoSubmitTimer: null
    };

    const id = this.stateService.params.id;
    this.trackeritemRest.getMergeStatus(id).then((result: any) => {
      this.tiMerge.promotionBranches = Object.keys(result.rel.merge_status);
    });

    this.refreshMergeDisplay();
    if (this.tiMerge.selectedCommit) {
      this.showDiff();
    }
  }

  ngOnChanges() {
    this.refreshMergeDisplay();
    if (this.tiMerge.selectedCommit) {
      this.showDiff();
    }
  }

  refreshMergeDisplay() {
    this.tiMerge.merge = false;

    const from = this.tiMerge.fromBranch || '';
    const to = this.tiMerge.toBranchCustom.name || this.tiMerge.toBranch || '';

    if (!from || !to) {
      return false;
    }

    this.tiMerge.loading = true;

    this.scmService.merge(this.stateService.params.unixName,
    {
      from: from,
      to: to,
      rel: 'diffs,commits,comments'
    })
    .then((data: any) => {
      this.tiMerge.merge = data;
      this.tiMerge.loading = false;
    }).catch((response: any) => {
      this.uiService.message.showWarning(response, 'Invalid Merge');
      this.tiMerge.loading = false;
    });
  }

  showDiff() {
    const commit = this.tiMerge.selectedCommit;
    const hash = commit?.commitHash || '';

    if (commit && !commit.rel?.diff) {
      this.tiMerge.loading = true;

      this.scmService.commitDiff(commit.project.unixName, hash,
        { rel: 'diff' })
      .then((data: any) => {
        this.tiMerge.selectedCommit.rel = data ? { diff: data.rel.diff } : false;
        this.tiMerge.loading = false;
      }).catch((response: any) => {
        this.uiService.message.showWarning(
          this.translateService.translate(
            'The specified commit ({{commit}}) does not exist in project ({{project}})',
            { commit: commit.commitHash, project: this.stateService.params.unixName }
          ), 
          this.translateService.translate('Not Found')
        );
        this.tiMerge.selectedCommit.rel = false;
        this.tiMerge.loading = false;
      });
    }
  }

  doMerge() {
    const from = this.tiMerge.fromBranch || '';
    const to = this.tiMerge.toBranchCustom.name || this.tiMerge.toBranch || '';

    if (from && to) {
      this.tiMerge.merging = true;

      this.scmService.saveMerge(this.stateService.params.unixName, 
      {
        from: from,
        to: to,
        rel: 'diffs,commits,comments'
      })
      .then((data: any) => {
        this.tiMerge.merge = data;
        this.tiMerge.merging = false;
        this.uiService.message.showSuccess(
          this.translateService.translate('Successfully merged {{from}} into {{to}}', { from: from, to: to }),
          this.translateService.translate('Merge Completed')
        );
      }).catch((response: any) => {
        this.tiMerge.merging = false;
        response.forEach((msg: any) => {
          this.uiService.message.showWarning(msg, this.translateService.translate('Merge Failed'));
        });
      });
    }
  }

  searchBranch(searchObj: any) {
    if (searchObj.name.length < 3) {
      return;
    }
    searchObj.searching = true;
    this.scmService.searchBranch(this.stateService.params.unixName, searchObj.name)
      .then((response: any) => {
        searchObj.searchItemsResult = response.items;
        searchObj.searching = false;
      });
  }

  addBranchAutoSubmit(searchObj: any) {
    if (searchObj.autoSubmitTimer) {
      clearTimeout(searchObj.autoSubmitTimer);
    }
    searchObj.autoSubmitTimer = setTimeout(() => {
      this.searchBranch(searchObj);
    }, 750);
  }

  addBranch(branch: string) {
    this.tiMerge.toBranchCustom.name = branch;
    this.tiMerge.toBranchCustom.searching = false;
    this.tiMerge.toBranchCustom.searchItemsResult = [];
  }
}
